import React, {
  createContext,
  useState,
  SetStateAction,
  Dispatch,
} from 'react';
import dayjs, { Dayjs } from 'dayjs';

import { Activities } from '../../models';
import { batchLogTimeSpentApi } from '../../services';

const ActivityTimeTrackerContext = createContext<TActivityTimeTrackerContext>({
  sendTrackedTime: () => {},
  setStartTimer: () => {},
});

export type TActivityTimeTrackerContext = {
  sendTrackedTime: (activity: Activities) => void;
  setStartTimer: Dispatch<SetStateAction<Dayjs>>;
};

interface AdminNotificationProviderProps {
  children: React.ReactNode;
}

function ActivityTimeTrackerProvider({
  children,
}: AdminNotificationProviderProps) {
  const [startTimer, setStartTimer] = useState(dayjs());

  async function sendTrackedTime(activity: Activities) {
    try {
      if (
        activity?.id &&
        activity?.type !== 'video' &&
        activity?.attemptsNum &&
        activity?.attemptsNum - (activity?.attemptsLeft || 0) !== 0
      ) {
        const res = await batchLogTimeSpentApi([
          {
            startTime: startTimer.format(),
            endTime: dayjs().format(),
            activityId: activity?.id,
            attempt:
              activity?.attemptsLeft && activity?.attemptsNum
                ? activity?.attemptsNum - activity?.attemptsLeft + 1
                : 1,
          },
        ]);

        if (res) {
          setStartTimer(dayjs());
        }
      }
    } catch (error) {
      console.log(
        'Something went wrong on sending tracked time for activity/assessment',
        error
      );
    }
  }

  return (
    <ActivityTimeTrackerContext.Provider
      value={{
        setStartTimer,
        sendTrackedTime,
      }}
    >
      {children}
    </ActivityTimeTrackerContext.Provider>
  );
}

export { ActivityTimeTrackerContext, ActivityTimeTrackerProvider };
